import Cookies from 'js-cookie';
import { v4 } from 'uuid';

export const POST_ACCESS_LOG = '/api/access_log/';

function getSessionIdAccessCookie() {
  return Cookies.get('sessionid_access');
}

function setSessionIdAccessCookie() {
  const sessionId = v4();
  Cookies.set('sessionid_access', sessionId, {
    expires: 60,
    domain: window.location.hostname.replace('www.', ''),
  });
}

const ensureSessionIdAccessCookie = (): string => {
  let sessionId = getSessionIdAccessCookie()!;

  if (!sessionId) {
    setSessionIdAccessCookie();
    sessionId = getSessionIdAccessCookie()!;
  }

  return sessionId;
};

/**
 * Defines whether the user is logged in or not based on sessionid_access.
 */
export const logSessionIdAccess = () => {
  const sessionId = ensureSessionIdAccessCookie();

  fetch(POST_ACCESS_LOG, {
    method: 'POST',
    headers: { session_id: sessionId },
    body: JSON.stringify({
      url: window.location.pathname,
      params: window.location.search,
      referrer: document.referrer,
    }),
  })
    .then()
    .catch(() => {
      console.warn('iwoca session id is not implemented yet');
    });
};
